module.exports = __webpack_public_path__ + "static/media/casa simeps 1.56fd1db0.svg";